// extracted by mini-css-extract-plugin
module.exports = {"root":"ClassicAbout_root__nLV6J"};